import { LiveAnnouncer } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ApiHistoryFull, Item } from '../../models/api-history-full';

@Component({
  selector: 'admin-list-api',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatButtonModule,
    MatIconModule,
    MatSortModule,
    MatMenuModule,
  ],
  templateUrl: './list-api.component.html',
  styleUrls: ['./list-api.component.scss'],
})
export class ListApiComponent implements OnChanges, AfterViewInit, OnInit {
  @Input() requests!: ApiHistoryFull;

  displayedColumns: string[] = [
    'partner',
    'clientCode',
    'date',
    'typeDeBien',
    'nombreReferences',
  ];

  dataSource!: MatTableDataSource<Item>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @Output() creditOrder = new EventEmitter<void>();
  @Output() deleteCredit = new EventEmitter<void>();

  constructor(private _liveAnnouncer: LiveAnnouncer) {}

  ngOnInit(): void {
    this.requests.items.forEach((item) => {
      item.happened_at = item.happened_at
        .replace(/(\d{4})-(\d{2})-(\d{2})/, '$3/$2/$1')
        .substring(0, 10);
    });
  }

  ngOnChanges(): void {
    this.dataSource = new MatTableDataSource<Item>(this.requests.items);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer
        .announce(`Sorted ${sortState.direction}ending`)
        .then(() => {});
    } else {
      this._liveAnnouncer.announce('Sorting cleared').then(() => {});
    }
  }
}
